import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationResolveSavedDocumentThreadArgs,
  BackendSavedDocumentThread,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ResolveSavedDocumentThread($threadId: ID!) {
    resolveSavedDocumentThread(threadId: $threadId) {
      id
    }
  }
`;

type Variables = BackendMutationResolveSavedDocumentThreadArgs;
type Result = Pick<BackendSavedDocumentThread, 'id'>;

export const resolveSavedDocumentThread = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
